// src/components/CustomHashLink.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function CustomHashLink({ to, children, className, onClick, offset = 80, ...rest }) {
  const navigate = useNavigate();

  const handle = (e) => {
    if (onClick) onClick(e);
    if (e.defaultPrevented) return;
    e.preventDefault();

    const [rawPath, rawHash] = to.split("#");
    const path = rawPath && rawPath.length ? rawPath : window.location.pathname;
    const hash = rawHash || "";

    if (path === window.location.pathname) {
      // same page
      if (window.location.hash === (hash ? `#${hash}` : "")) {
        // same hash - force scroll now
        const el = document.getElementById(hash);
        if (el) {
          const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top, behavior: "smooth" });
        }
      } else {
        // change hash - triggers hashchange and ScrollToHash fallback
        window.location.hash = hash ? `#${hash}` : "";
      }
    } else {
      // navigate to different path (include hash) - ScrollToHash will handle waiting & scrolling
      navigate(path + (hash ? `#${hash}` : ""));
    }
  };

  return (
    <a href={to} onClick={handle} className={className} {...rest}>
      {children}
    </a>
  );
}
